const colors = [
  '#1abc9c',
  '#2ecc71',
  '#3498db',
  '#9b59b6',
  '#34495e',
  '#16a085',
  '#27ae60',
  '#2980b9',
  '#8e44ad',
  '#2c3e50',
  '#f1c40f',
  '#e67e22',
  '#e74c3c',
  '#ecf0f1',
  '#95a5a6',
  '#f39c12',
  '#d35400',
  '#c0392b',
  '#bdc3c7',
  '#7f8c8d',
];

type Props = {
  name?: string;
  size?: number;
};

export const generateDataImage = ({ name = '', size = 60 }: Props): string | null => {
  let initials: string;
  const generateImageFromInitials = String(name).toUpperCase().split(' ');
  const charCodeSum = name
    .split('')
    .map((c: string) => c.charCodeAt(0))
    .reduce((a: number, b: number) => a + b, 0);

  if (generateImageFromInitials.length === 1) {
    initials = generateImageFromInitials[0] ? generateImageFromInitials[0].charAt(0) : '?';
  } else {
    initials = generateImageFromInitials[0].charAt(0) + generateImageFromInitials[1].charAt(0);
  }

  if (window.devicePixelRatio) {
    size = size * window.devicePixelRatio;
  }

  const charIndex = (initials === '?' ? 72 : charCodeSum) - 64;
  const colourIndex = charIndex % colors.length;

  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext('2d');

  if (!context) return null;

  context.fillStyle = colors[colourIndex];
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.font = 'bold ' + Math.round(canvas.width / 2) + 'px "Proxima Nova"';
  context.textAlign = 'center';
  context.fillStyle = '#FFF';
  context.fillText(initials, size / 2, size / 1.5);

  return canvas.toDataURL();
};
